/**
 * 从缓存获取用户资料对象
 *
 * @template T 用户对象模版
 * @param {string} [key] 缓存 Key
 * @returns {T | undefined} 用户资料对象
 */
export function getCachedProfile<T = Record<string, any>>(key: string = 'profile'): T | undefined {
  const cachedProfile = localStorage.getItem(key)

  if (!cachedProfile) {
    return undefined
  }

  try {
    return JSON.parse(cachedProfile) as T
  } catch (error: any) {
    console.warn(error.message || 'Parse profile error')
    return undefined
  }
}

/**
 * 保存用户资料对象到缓存
 *
 * @template T 用户对象模版
 * @param {T} user 用户资料对象
 * @param {string} [key] 缓存 Key
 */
export function saveProfile<T = Record<string, any>>(user: T, key: string = 'profile'): void {
  localStorage.setItem(key, JSON.stringify(user))
}

/**
 * 删除用户资料对象缓存
 *
 * @param {string} [key] 缓存 Key
 */
export function clearProfile(key: string = 'profile'): void {
  localStorage.removeItem(key)
}
